import './TopAppBar.scss';
import Control from "../../Control";
import Delegate from "../../Delegate";
import NP from "../../NP";
import IconToggleButton from "../IconToggleButton/IconToggleButton";
import Button from "../Button/Button";
import TabControl from "../TabControl/TabControl";
import Switcher from "../Switcher/Switcher";
import CheckBox from "../CheckBox/CheckBox";

export default class TopAppBar extends Control {

	EvCaptionClick: Delegate;
	EvCaptionDblClick: Delegate;
	EvSearch: Delegate;
	EvHideSearch: Delegate;
	EvFocusSearch: Delegate;
	EvAppBarTabSelected: Delegate;
	EvBackClick: Delegate;

	_Caption: string;
	_RightItems: Control[];
	_NavMenuItems: { Content: string, Value: string }[];
	_SelectedNavMenuSection: number;
	_MainButton: IconToggleButton | Button;
	_Logo: { Img?: string, Title?: string, Link?: string, Divider?: boolean };
	_ShowSearchButton: boolean;
	_ShowBackButton: boolean;
	_MainButtonVisible: boolean;

	_toolBarNode: HTMLElement;
	_leftBarNode: HTMLElement;
	_captionNode: HTMLElement;
	_tabsNode: HTMLElement;
	_progressNode: HTMLElement;
	_logoNode: HTMLElement;
	_logoImg: HTMLElement;
	_logoTitle: HTMLElement;
	_searchInput: HTMLInputElement;
	_searchBtn: IconToggleButton;
	_hideSearchBtn: IconToggleButton;
	_backBtn: IconToggleButton;
	_searchTimeout: number;
	_mainVisBefore: boolean;


	constructor(settings: object)
	{
		super(settings);
		this._render();
	}

	_initFields(settings: object)
	{
		this._Caption = "";
		this._RightItems = [];
		this._NavMenuItems = [];
		this._SelectedNavMenuSection = 0;
		this._MainButton = null;
		this._Logo = null;
		this._ShowSearchButton =
			 this._ShowBackButton = false;
		this.EvBackClick = new Delegate();
		this.EvCaptionClick = new Delegate();
		this.EvCaptionDblClick = new Delegate();
		this.EvSearch = new Delegate();
		this.EvHideSearch = new Delegate();
		this.EvFocusSearch = new Delegate();
		this.EvAppBarTabSelected = new Delegate();
		super._initFields(settings);
	}

	_render()
	{
		this.np_render(`<header class="top-app-bar">
  <div class="top-app-bar__row">
    <section class="top-app-bar__section top-app-bar__section--align-start">
      <span class="top-app-bar__title" title="${this._Caption}">
			${this._Caption}
		</span>
    </section>
    <section class="top-app-bar__section top-app-bar__section--align-end" role="toolbar">
    </section>
  </div>
</header>`);

		this._leftBarNode = this._root.querySelector('.top-app-bar__section--align-start');
		this._toolBarNode = this._root.querySelector('.top-app-bar__section--align-end');

		this._RightItems.push(this._searchBtn = new IconToggleButton({
			FontImage: NP.FontImages.search,
			ParentNode: this._toolBarNode,
			Value: 'Search',
			EvClick: () => this._showSearchPanel()
		}));

		this._RightItems.forEach((item: any, i: number) =>
		{
			if (!item)
				return;
			if (item instanceof Control)
			{
				item.putToNode(this._toolBarNode);
			}
			else if (item.IsSeparator)
			{
				item.Node = NP.createNode(this._toolBarNode, 'top-app-bar__divider');
			}
			else
			{
				item.ParentNode = this._toolBarNode;
				this._RightItems[i] = new IconToggleButton(item);
			}
		});

		this._captionNode = this._root.querySelector('.top-app-bar__title');

		this.addEvent(this._captionNode, 'click', this._onCaptionClick)
		this.addEvent(this._captionNode, 'dblclick', this.onCaptionDblClick)

		this.setLogo(this._Logo);

		if (this._NavMenuItems.length > 0)
		{
			this._renderNavMenu();
			this._toolBarNode.classList.add('top-app-bar__section--equal-width');
			(this._captionNode.parentNode as HTMLElement).classList.add('top-app-bar__section--equal-width');
		}

		this._MainButtonVisible = !!this._MainButton;
		this._MainButton = new IconToggleButton(this._MainButton);
		if (this._MainButtonVisible)
			this._MainButton.putToNode(this._captionNode.parentNode as HTMLElement, this._captionNode);

		this._hideSearchBtn = new IconToggleButton({
			FontImage: NP.FontImages.arrow_back,
			EvClick: () => this.hideSearch()
		});
		this._hideSearchBtn.putToNode(this._captionNode.parentNode as HTMLElement, this._captionNode);
		this._hideSearchBtn.hide();

		this._backBtn = new IconToggleButton({
			FontImage: NP.FontImages.arrow_back,
			ToolTip: NP.RM.getString("Back"),
			EvClick: () => this.EvBackClick.fire(this)
		});
		this.addLeftItem(this._backBtn, this.getLeftItemsNode().firstChild as HTMLElement);
		this._backBtn.setIsVisible(this._ShowBackButton);

		if (this._Caption)
			this.setCaption(this._Caption);

		this._searchInput = document.createElement('input');
		this._searchInput.className = 'top-app-bar__search-input';
		this._captionNode.parentNode.appendChild(this._searchInput);
		this._searchInput.setAttribute("placeholder", NP.RM.getString('SearchInput'));
		this.addEvent(this._searchInput, 'change', this._onSearchInputChanged);
		this.addEvent(this._searchInput, 'keydown', this._onSearchInputKeyDown);
		NP.hideNode(this._searchInput);

		this.setShowSearchButton(this._ShowSearchButton);
	}

	addRightItem(btn: IconToggleButton | Button | CheckBox, beforeNode?: HTMLElement)
	{
		this._RightItems.push(btn);
		btn.putToNode(this._toolBarNode, beforeNode);
	}

	addLeftItem(btn: IconToggleButton, beforeNode?: HTMLElement)
	{
		btn.putToNode(this._leftBarNode, beforeNode);
	}

	getRightItemsNode()
	{
		return this._toolBarNode;
	}

	getLeftItemsNode()
	{
		return this._leftBarNode;
	}

	_renderNavMenu()
	{
		this._renderTabsMenu();
	}

	_renderTabsMenu()
	{
		this._tabsNode = NP.createNode(this._root, 'top-app-bar__tabs-menu');
		this._toolBarNode.parentNode.insertBefore(this._tabsNode, this._toolBarNode);
		new TabControl({
			ParentNode: this._tabsNode,
			FullHeight: true,
			SelectedIndex: this._SelectedNavMenuSection,
			Items: this._NavMenuItems,
			EvTabSelected: (sender: TabControl, args: { Value: string }) => this.EvAppBarTabSelected.fire(this, args)
		});
	}

	_onSearchInputChanged()
	{
		if (this._searchTimeout)
			clearTimeout(this._searchTimeout);
		this.EvSearch.fire(this, {Value: this._searchInput.value});
	}

	_onSearchInputKeyDown()
	{
		if (this._searchTimeout)
			clearTimeout(this._searchTimeout);

		this._searchTimeout = <any>setTimeout(() =>
		{
			if (this.isLive())
			{
				this._searchTimeout = null;
				this.EvSearch.fire(this, {Value: this._searchInput.value});
			}
		}, 3000);
	}

	setShowSearchButton(value: boolean)
	{
		this._ShowSearchButton = value;
		if (this._searchBtn)
			this._searchBtn.setIsVisible(value);
	}

	setShowBackButton(value: boolean)
	{
		this._ShowBackButton = value;
		if (this._backBtn)
			this._backBtn.setIsVisible(value);
	}

	_showSearchPanel()
	{
		NP.showNode(this._searchInput);
		if (this.hasClass('top-app-bar--dark'))
			this.addClass('top-app-bar--white');

		this._hideSearchBtn.show();
		this._backBtn.setIsVisible(false);

		this._mainVisBefore = this._MainButton.getIsVisible()
			 && this._MainButton.getParentNode() == this.getLeftItemsNode(); //исключаем случай когда MainButton вынесена из topAppBar, например когда в диалоге кнопка закрытия внешняя
		if (this._mainVisBefore)
			this._MainButton.hide();

		NP.hideNodes([this._captionNode, this._toolBarNode]);
		this._searchInput.focus();
		this.EvFocusSearch.fire(this);
	}

	hideSearch(fireEvent?: boolean)
	{
		if (this.hasClass('top-app-bar--dark'))
			this.removeClass('top-app-bar--white');
		NP.hideNode(this._searchInput);
		this._searchInput.value = "";

		this._hideSearchBtn.hide();
		this._backBtn.setIsVisible(this._ShowBackButton);

		if (this._mainVisBefore)
		{
			this._MainButton.putToNode(this._captionNode.parentNode as HTMLElement, this._captionNode);
			this._MainButton.show();
		}

		NP.showNodes([this._captionNode, this._toolBarNode]);

		if (fireEvent !== false)
			this.EvHideSearch.fire(this);
	}

	addItem(ctrl: IconToggleButton | Button | Switcher, beforeItem?: Control)
	{
		this._RightItems.push(ctrl);
		if (beforeItem)
		{
			ctrl.putToNode(this._toolBarNode, beforeItem.getRoot());
		}
		else
		{
			ctrl.putToNode(this._toolBarNode);
		}
	}

	removeItem(ctrl: Control)
	{
		ctrl.hide();
		NP.removeFromArray(this._RightItems, ctrl);
	}

	_onCaptionClick()
	{
		this.EvCaptionClick.fire(this);
	}

	private onCaptionDblClick()
	{
		this.EvCaptionDblClick.fire(this);
	}

	getMainButton()
	{
		return this._MainButton;
	}

	getItem(value: any): IconToggleButton | Button
	{
		return this._RightItems.find(x => x.getValue && x.getValue() == value || (x as any).Value == value) as IconToggleButton;
	}

	hideSeparator(value: any)
	{
		let sep = this._RightItems.find(x => (<any>x).Value == value);
		if (sep)
			NP.hide((<any>sep).Node);
	}

	showSeparator(value: any)
	{
		let sep = this._RightItems.find(x => (<any>x).Value == value);
		if (sep)
			NP.show((<any>sep).Node);
	}

	setSeparatorVisible(value: any, visible: boolean)
	{
		if (visible)
			this.showSeparator(value);
		else
			this.hideSeparator(value);
	}

	getRightItems()
	{
		return this._RightItems;
	}

	setCaption(value: string)
	{
		this._Caption = value;
		this._captionNode.innerHTML = " " + NP.escapeHTML(value); //Если убрать " ", то в экспорте PDF не будет видно заголовка с русским текстом
		if (value)
			this._captionNode.setAttribute("title", value);
		else
			this._captionNode.removeAttribute("title");
	}

	getCaptionNode()
	{
		return this._captionNode;
	}

	getCaption()
	{
		return this._Caption;
	}

	showWaiter()
	{
		if (!this._progressNode)
		{
			this._progressNode = NP.parseHTMLC(`<div role="progressbar" class="mdc-linear-progress mdc-linear-progress--indeterminate">
  <div class="mdc-linear-progress__buffering-dots"></div>
  <div class="mdc-linear-progress__buffer"></div>
  <div class="mdc-linear-progress__bar mdc-linear-progress__primary-bar">
    <span class="mdc-linear-progress__bar-inner"></span>
  </div>
  <div class="mdc-linear-progress__bar mdc-linear-progress__secondary-bar">
    <span class="mdc-linear-progress__bar-inner"></span>
  </div>
</div>`);
		}
		this._root.appendChild(this._progressNode);
		this.addClass('top-app-bar--has-progress');
	}

	hideWaiter()
	{
		NP.removeFromParent(this._progressNode);
		this.removeClass('top-app-bar--has-progress');
	}

	setScrollShadowVisible(value: boolean)
	{
		if (value)
			this.addClass('top-app-bar--fixed-scrolled');
		else
			this.removeClass('top-app-bar--fixed-scrolled');
	}

	setLogo(logoArgs: { Img?: string, Title?: string, Link?: string, Divider?: boolean })
	{
		if (logoArgs)
		{
			this._Logo = logoArgs;

			if (this._logoNode)
				this.removeLogo();

			this._logoNode = logoArgs.Link
				 ? NP.createNode(this._root, 'top-app-bar__logo top-app-bar__logo--link', 'a')
				 : NP.createNode(this._root, 'top-app-bar__logo');

			if (this._Logo.Img)
			{
				this._logoImg = NP.createNode(this._logoNode, 'top-app-bar__logo-img', 'img');
				this._logoImg.setAttribute('src', this._Logo.Img);
			}

			if (this._Logo.Title)
			{
				this._logoTitle = NP.createNode(this._logoNode, 'top-app-bar__logo-title', 'span');
				this._logoTitle.innerHTML = this._Logo.Title;
			}

			if (this._Logo.Divider && (this._Logo.Title || this._Logo.Img))
				NP.createNode(this._logoNode, 'top-app-bar__divider');

			if (this._Logo.Link)
				this._logoNode.setAttribute('href', this._Logo.Link);
			else
				this._logoNode.removeAttribute('href');

			this._captionNode.parentNode.insertBefore(this._logoNode, this._captionNode);
		}
	}

	removeLogo()
	{
		if (this._logoNode)
			this._logoNode.remove();
	}

	getLogo()
	{
		return this._logoNode;
	}
}